
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { CompanyModel } from './Entities.GormCrm.Company';
import { ReasonModel } from './Entities.GormCrm.Reason';
import { OrderCancellationModel } from './Entities.GormCrm.OrderCancellation';
import { OrderLineModel } from './Entities.GormCrm.OrderLine';
import { OrderProductPlanDiscontinuationModel } from './Entities.GormCrm.OrderProductPlanDiscontinuation';
import { OrderWarningModel } from './Entities.GormCrm.OrderWarning';
import { PlanReplacementModel } from './Entities.GormCrm.PlanReplacement';
import { QuestionnaireQuestionReplyModel } from './Entities.GormCrm.QuestionnaireQuestionReply';
import { SaleAgreementModel } from './Entities.GormCrm.SaleAgreement';
import { SaleAttachmentModel } from './Entities.GormCrm.SaleAttachment';
import { Model, ModelProperty } from 'models/Model';


export class OrderModel extends Model<OrderModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'string', isHidden: true },
		{ name: 'created', type: 'Date', isHidden: true },
		{ name: 'companyId', type: 'string' },
		{ name: 'sellerId', type: 'string' },
		{ name: 'salesTeamId', type: 'string' },
		{ name: 'signDate', type: 'Date' },
		{ name: 'approvedDate', type: 'Date' },
		{ name: 'approvalUserId', type: 'string' },
		{ name: 'saleAgreementId', type: 'string' },
		{ name: 'referenceNumber', type: 'number' },
		{ name: 'withholdCommission', type: 'boolean' },
		{ name: 'companyHadActivePlans', type: 'boolean' },
		{ name: 'leadUserId', type: 'string' },
		{ name: 'discountReasonId', type: 'string' },
		{ name: 'externalRemainingAmount', type: 'number' },
		{ name: 'externalAnnualValueForRenewal', type: 'number' },
		{ name: 'autoDelivery', type: 'boolean' },
		{ name: 'company', type: 'CompanyModel', isHidden: true, isObject: true, new: () => { return new CompanyModel }, properties: () => { return CompanyModel.classProperties } },
		{ name: 'discountReason', type: 'ReasonModel', isHidden: true, isObject: true, new: () => { return new ReasonModel }, properties: () => { return ReasonModel.classProperties } },
		{ name: 'orderCancellations', type: 'OrderCancellationModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new OrderCancellationModel }, properties: () => { return OrderCancellationModel.classProperties } },
		{ name: 'orderLines', type: 'OrderLineModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new OrderLineModel }, properties: () => { return OrderLineModel.classProperties } },
		{ name: 'orderProductPlanDiscontinuations', type: 'OrderProductPlanDiscontinuationModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new OrderProductPlanDiscontinuationModel }, properties: () => { return OrderProductPlanDiscontinuationModel.classProperties } },
		{ name: 'orderWarnings', type: 'OrderWarningModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new OrderWarningModel }, properties: () => { return OrderWarningModel.classProperties } },
		{ name: 'planReplacements', type: 'PlanReplacementModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new PlanReplacementModel }, properties: () => { return PlanReplacementModel.classProperties } },
		{ name: 'questionnaireQuestionReplies', type: 'QuestionnaireQuestionReplyModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new QuestionnaireQuestionReplyModel }, properties: () => { return QuestionnaireQuestionReplyModel.classProperties } },
		{ name: 'saleAgreement', type: 'SaleAgreementModel', isHidden: true, isObject: true, new: () => { return new SaleAgreementModel }, properties: () => { return SaleAgreementModel.classProperties } },
		{ name: 'saleAttachments', type: 'SaleAttachmentModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new SaleAttachmentModel }, properties: () => { return SaleAttachmentModel.classProperties } }
	];
	[key: string]: any;
	
	public id?: string;
	public created?: Date;
	public companyId?: string;
	public sellerId?: string;
	public salesTeamId?: string;
	public signDate?: Date;
	public approvedDate?: Date;
	public approvalUserId?: string;
	public saleAgreementId?: string;
	public referenceNumber: number;
	public withholdCommission: boolean;
	public companyHadActivePlans: boolean;
	public leadUserId?: string;
	public discountReasonId?: string;
	public externalRemainingAmount?: number;
	public externalAnnualValueForRenewal?: number;
	public autoDelivery: boolean;
	public company?: CompanyModel;
	public discountReason?: ReasonModel;
	public orderCancellations: OrderCancellationModel[];
	public orderLines: OrderLineModel[];
	public orderProductPlanDiscontinuations: OrderProductPlanDiscontinuationModel[];
	public orderWarnings: OrderWarningModel[];
	public planReplacements: PlanReplacementModel[];
	public questionnaireQuestionReplies: QuestionnaireQuestionReplyModel[];
	public saleAgreement?: SaleAgreementModel;
	public saleAttachments: SaleAttachmentModel[];
    
	constructor(){
		super();
		this.id = undefined;
		this.created = undefined;
		this.companyId = undefined;
		this.sellerId = undefined;
		this.salesTeamId = undefined;
		this.signDate = undefined;
		this.approvedDate = undefined;
		this.approvalUserId = undefined;
		this.saleAgreementId = undefined;
		this.referenceNumber = 0;
		this.withholdCommission = false;
		this.companyHadActivePlans = false;
		this.leadUserId = undefined;
		this.discountReasonId = undefined;
		this.externalRemainingAmount = undefined;
		this.externalAnnualValueForRenewal = undefined;
		this.autoDelivery = false;
		this.company = undefined;
		this.discountReason = undefined;
		this.orderCancellations = [];
		this.orderLines = [];
		this.orderProductPlanDiscontinuations = [];
		this.orderWarnings = [];
		this.planReplacements = [];
		this.questionnaireQuestionReplies = [];
		this.saleAgreement = undefined;
		this.saleAttachments = [];
		
	}
	getProperties(){
		return OrderModel.classProperties;
	}
}

